import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import client1 from "../../assets/Images/2.jpeg";
import client2 from "../../assets/Images/anoop.jpeg";
import client3 from "../../assets/Images/srisha.jpeg";
import client4 from "../../assets/Images/tourist1.jpg";
import client5 from "../../assets/Images/Magnetic-hill-Ladakh-Places-to-Visit-in-Ladakh-1000x800.jpg.jpg";
import "./ClientSays.css";


const clients = [
  {
    img: client1,
    testimonial: "An unforgettable journey, stunning views, luxurious stays, and amazing guidance throughout! Adventure wrapped in pure bliss!",
  },
  {
    img: client2,
    testimonial: "Great experience-friendly guide, comfy stay, and breathtaking scenery! Feel free, ride the wild.",
  },
  {
    img: client3,
    testimonial: "Smooth rides, great stays—CK and Tonwang handled everything perfectly. Care, culture, and flawless journeys.",
  },
  {
    img: client4,
    testimonial: "A wonderful experience with great support.",
  },
  {
    img: client5,
    testimonial: "Perfectly organized trip, very satisfying!",
  },
];


const ClientSays = () => {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    const interval = setInterval(() => {
      const slideWidth = 320; // Approx width of one slide including margin
      if (slider) {
        slider.scrollLeft += slideWidth;
        scrollAmount += slideWidth;

        // Reset halfway (because content is duplicated)
        if (scrollAmount >= slider.scrollWidth / 2) {
          slider.scrollLeft = 0;
          scrollAmount = 0;
        }
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const navigate = useNavigate();

const contact = () => {
  navigate("/contact-us");
}


  return (
    <div className="container-fluid pt-5">
      <div className="row mb-4 justify-content-center">
        <div className="col-lg-6 d-flex flex-column align-items-start justify-content-center ps-5">
          <button
            style={{
              borderRadius: "10px",
              backgroundColor: "white",
              width: "fit-content",
            }}
          >
            Testimonials
          </button>
          <h3
            className="mt-3"
            style={{
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: "42px",
              lineHeight: "100%",
              letterSpacing: "0%",
            }}
          >
            Reliable service and passionate guides bring Ladakh’s wonders to life.
          </h3>
        </div>
        <div className="col-lg-6 d-flex flex-column align-items-start ps-4 pt-3 mt-5">
          <p
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "100%",
              letterSpacing: "0%",
            }}
          >
            Travel through Ladakh’s wild beauty and cultural heritage with comfort, safety, and expert guidance every step.
          </p>
          <button onClick={contact} style={{ borderRadius: "20px", backgroundColor: "white", padding: "10px 20px" }}>
            Get Started 
          </button>
        </div>
      </div>

      <div className="image-slider" ref={sliderRef}>
  {[...clients, ...clients].map((client, index) => (
    <div className="slide-img position-relative" key={index}>
      <img src={client.img} alt={`Client ${index + 1}`} />
      <div className="glass-overlay-text">
        <div className="d-flex align-items-center gap-2">
          <div className="avatar-placeholder"></div>
          <p className="m-0">
            {client.testimonial.split(' ').length > 6
              ? client.testimonial.split(' ').slice(0, 4).join(' ') + '...'
              : client.testimonial}
          </p>
        </div>
      </div>
    </div>
  ))}
</div>

    </div>
  );
};

export default ClientSays;
